import ProductCardRenderer from "../../common/product-card-renderer";
const productCardRenderer = ProductCardRenderer();

const getSearchInsights = () => {
  if (window.fstore.searchInsights) {
    return window.fstore.searchInsights;
  }
  const searchInsights = require("search-insights");
  searchInsights("init", {
    appId: "ZGISPFZEQK",
    apiKey: "ebbe04351ebe8091e1d417fe4ed7d8b3",
  });
  window.fstore.searchInsights = searchInsights;
  return searchInsights;
};

const renderAlgoliaProducts = (result, el, noResultEl) => {
  if (noResultEl) {
    if (result.products.length <= 0) {
      el.classList.remove("has-items");
      noResultEl.classList.add("show");
    } else {
      el.classList.add("has-items");
      noResultEl.classList.remove("show");
    }
  }

  const isEnd = result.page >= result.nbPages;
  const newLength = isEnd ? result.products.length : Math.floor(result.products.length / 6) * 6;
  const trimmed = result.products.slice(0, newLength);

  const items = trimmed.map((product) => {
    const item = productCardRenderer.renderAlgoliaProduct(product, result.indexName, result.queryID);
    return `<div class="fs-collection-grid-item">${item}</div>`;
  });
  el.innerHTML = items.join("");

  const ids = trimmed.filter((p) => p.variants_count == 1 || !p.image).map((p) => "gid://shopify/Product/" + p.id);
  window.ShopifyClient.fetchProducts(ids)
    .then((products) => {
      products.forEach((product) => productCardRenderer.addHoverImage(el, product));
    })
    .catch((e) => {
      /* console.error(e) */
    });

  productCardRenderer.addClickedObjectIDsAfterSearch(el, getSearchInsights());
  productCardRenderer.addWishlistButtonListener(el);
};

const renderShopifyProducts = (products, el, noResultEl) => {
  if (products.length <= 0) {
    el.classList.remove("has-items");
    noResultEl.classList.add("show");
  } else {
    el.classList.add("has-items");
    noResultEl.classList.remove("show");
  }
  const items = products.map((product) => {
    const colorOption = product.options.find((option) => option.name == "色");
    if (colorOption && 2 <= colorOption.values.length) {
      return colorOption.values
        .map((color) => {
          const item = productCardRenderer.renderShopifyProduct(product, color);
          return `<div class="fs-collection-grid-item">${item}</div>`;
        })
        .join("");
    }
    const item = productCardRenderer.renderShopifyProduct(product, -1);
    return `<div class="fs-collection-grid-item">${item}</div>`;
  });
  el.innerHTML = items.join("");

  productCardRenderer.addWishlistButtonListener(el);
};

const run = (result, el, noResultEl) => {
  if (result.resultType == "algolia") {
    renderAlgoliaProducts(result, el, noResultEl);
  } else {
    renderShopifyProducts(result.products, el, noResultEl);
  }
};

const ProductsRenderer = {
  run: run,
};

export default ProductsRenderer;
